var mianliao = {
    "app_id": 207917,
    "AppId": "",
    "map": [
        // 中文版 https://izt.eastfair.cn/h5-web/#/mlact
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/zhanguan.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/Services1.png|https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/Services2.png&title=一览图", // 多个用|分隔 参考注释
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/zhanwei.png",
            "url": "/conference?theme=mianliao&key=mapDetail&title=展位图",
            // "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/expect.jpg&title=展位图",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/jiaotong.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/Traffic.jpg|https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/Traffic1.jpg&title=交通图",
            "urlType": "TOPATH"
        }
    ],
    // 中文版 https://izt.eastfair.cn/h5-web/#/mlact
    "mapDetail": [
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/1.2CN.jpg",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/1.2H.jpg&title=展位图",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/5.1CN.jpg",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/5.1H.jpg&title=展位图",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/6.1CN.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/6.1H.jpg&title=展位图",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/6.2CN.jpg",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/6.2H.jpg&title=展位图",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/7.1CN.jpg",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/7.1H.jpg&title=展位图",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/7.2CN.jpg",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/7.2H.jpg&title=展位图",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/8.1CN.jpg",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/8.1H.jpg&title=展位图",
            "urlType": "TOPATH"
        }
    ],
    // 沙线访问路径 https://izt.eastfair.cn/h5-web/#/conference?theme=mianliao&key=sxmap
    "sxmap": [
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/zhanguan.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/layout.png&title=展馆分布图",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/zhanwei.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/sxzw.jpg&title=展位图",
            // "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/expect.jpg",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/jiaotong.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/traffic.png&title=交通图",
            // "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/expect.jpg",
            "urlType": "TOPATH"
        }
    ],
    // 英文版 https://izt.eastfair.cn/h5-web/#/conference?theme=mianliao&key=hwmap
    "hwmap": [
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/zhanguan_en.png",
            // "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/2023/view.png|https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/2023/traffic.png&title=Hall Overview",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/Services1.png|https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/Services2.png&title=Hall Overview",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/zhanwei_en.png",
            "url": "/conference?theme=mianliao&key=hwMapDetail&title=Hall Plan",
            // "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/expect.jpg&title=Hall Plan",
            "urlType": "TOPATH"
        }
    ],
    // 英文版地址 https://izt.eastfair.cn/h5-web/#/conference?theme=mianliao&key=hwMapDetail
    "hwMapDetail": [
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/1.2EN.jpg",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/1.2H.jpg&title=Hall Plan",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/5.1EN.jpg",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/5.1H.jpg&title=Hall Plan",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/6.1EN.jpg",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/6.1H.jpg&title=Hall Plan",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/6.2EN.jpg",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/6.2H.jpg&title=Hall Plan",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/7.1EN.jpg",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/7.1H.jpg&title=Hall Plan",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/7.2EN.jpg",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/7.2H.jpg&title=Hall Plan",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/8.1EN.jpg",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/mianliao/ZhanWeiTu/8.1H.jpg&title=Hall Plan",
            "urlType": "TOPATH"
        },
    ]
}

export default mianliao;